import $http from '$http';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';
import {
    GetProvinces,
    GetCitys,
    GetAreas,
    GetAgentList,
    GetParmConfig, //寄送，支付接口
    GetProductClass,
    GetAgentConsigneeList,
    Consignee_Add,
    GetEmployList,
    ConsigneeSetDefault
} from '@api/commonApi.js';
import {
    GetOrderFinanceAuditByPage,
    ERP_AuditOrder,
    GetERP_OrderById
} from '@api/orderApi';
export default {
    methods: {
        //获取列表
        //初始化加载页面
        List() {
            this.lists = [];
            this.loading = true; //拼命加载中显示
            var params = this.getParams();
            $http.get("api/BookOnlyOrder/GetBookOnlyOrderFinanceAuditByPage", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    for (var i = 0; i < Data.length; i++) {
                        Data[i].AreaName = Data[i].AreaName.split("市")[0] + '市'
                        if (Data[i].AreaName == "北京北京市") {
                            Data[i].AreaName = "北京市"
                        }
                        if (Data[i].AreaName == "重庆重庆市") {
                            Data[i].AreaName = "重庆市"
                        }
                        if (Data[i].AreaName == "上海上海市") {
                            Data[i].AreaName = "上海市"
                        }
                        if (Data[i].AreaName == "天津天津市") {
                            Data[i].AreaName = "天津市"
                        }
                    }
                    this.lists = Data;
                    this.totalSize = Cnt;
                });

            });

        },
        // getList()  {
        //     let params = { 
        //         Sid: this.$store.state.sysSid, 
        //         Session: this.$store.state.sysSession, 
        //         pageIndex: this.pageIndex,
        //         pageSize: this.pageSize
        //      };
        //     //过滤没有查询的值传入服务器
        //     for (var i in this.query) {
        //         if (this.query.hasOwnProperty(i)) {
        //             if (isCorrectVal(this.query[i])) {
        //                 params[i] = this.query[i]
        //             }
        //         };
        //     }
        //     this.loading = true;
        //     $http.get("api/MeetOrder/GetMeetOrderByPage", params).then(res => {
        //         let { Data, Cnt } = res.data;
        //         this.loading = false;
        //         util.doResult(this, res, () => {
        //             this.lists = Data;
        //             this.totalSize = Cnt;
        //         });
        //     });
        // },
        // // 删除
        // DelList(OrderId)  {
        //     let params = { 
        //         Sid: this.$store.state.sysSid, 
        //         Session: this.$store.state.sysSession, 
        //         OrderId:OrderId
        //      };
        //     this.loading = true;
        //     $http.get("api/MeetOrder/MeetOrderDel", params).then(res => {
        //         let { Data, Cnt } = res.data;
        //         this.loading = false;
        //         util.doResult(this, res, () => {
        //             this.$notify({
        //                 title: '成功',
        //                 message: "删除成功",
        //                 type: 'success'
        //             });
        //             this.getList()
        //         });
        //     });
        // },
    }
}


// WEBPACK FOOTER //
// ./src/pages/Order/orderAudit/services.js